import { CSSProperties } from "react";
import { formatNumber, hexToRgb } from "utils/helpers";
import styles from "./styles.module.css";

function getGradient(color: any, progress: any) {
  return `repeating-linear-gradient(
  45deg,
  rgba(${hexToRgb(color)}, ${progress / 100}),
  rgba(${hexToRgb(color)}, 0.7) 10px,
  rgba(${hexToRgb(color)}, ${progress / 100}) 10px,
  rgba(${hexToRgb(color)}, 0.7) 20px
)`;
}

export function CustomProgressBar({
  progress = 58,
  color = "#000000",
  height = 25,
}: any) {
  return (
    <div
      className={styles.progressBarOuter}
      style={{ height, "--color": hexToRgb(color) } as CSSProperties}
    >
      <div
        className={`${styles.progressBarInner} ${styles.gradient}`}
        style={{
          width: `${progress}%`,
          height,
        }}
        title={progress + "%"}
      >
        {progress}%
      </div>
    </div>
  );
}

export function SmallProgressBarwithRatio({
  value = 0,
  target = 10,
  color = "#008000",
  height = 20,
}: any) {
  const progress = Math.ceil((value / target) * 100);
  return (
    <div
      style={
        {
          height,
          "--color": hexToRgb(color),
          width: "100px",
        } as CSSProperties
      }
      className={styles.progressBarOuterSm}
    >
      <div
        className={`${styles.progressBarInnerSm}`}
        style={{
          width: `${progress}%`,
          height,
          background: progress ? getGradient(color, progress) : "",
        }}
        title={progress + "%"}
      ></div>
      <div className={styles.value}>
        {/* {formatNumber(value)}/{formatNumber(target)} */}
        {formatNumber(progress)}%
      </div>
    </div>
  );
}
